import { http, HttpResponse } from 'msw';
import { getDummyBookmark } from '@stashmark/shared';
import type { CreateBookmark, UpdateBookmark, PaginatedResponse } from '@stashmark/shared';

const BASE_URL = 'http://localhost:3001';

/**
 * Returns an absolute URL for a given path.
 * Used primarily in tests where an absolute URL is required by Node.js.
 */
export function api(path: string) {
  return new URL(path, BASE_URL).href;
}

const bookmarks = [getDummyBookmark({ id: 'bookmark-1' }), getDummyBookmark({ id: 'bookmark-2' })];

/**
 * Common handlers that match both relative (browser) and absolute (Vitest) paths.
 */
export const handlers = [
  // GET /api/bookmarks
  http.get('/api/bookmarks', () => {
    const response: PaginatedResponse<(typeof bookmarks)[0]> = {
      data: bookmarks,
      pagination: {
        page: 1,
        limit: 20,
        total: bookmarks.length,
        totalPages: 1,
      },
    };
    return HttpResponse.json({ success: true, data: response });
  }),
  http.get(api('/api/bookmarks'), () => {
    const response: PaginatedResponse<(typeof bookmarks)[0]> = {
      data: bookmarks,
      pagination: {
        page: 1,
        limit: 20,
        total: bookmarks.length,
        totalPages: 1,
      },
    };
    return HttpResponse.json({ success: true, data: response });
  }),

  // GET /api/bookmarks/:id
  http.get('/api/bookmarks/:id', ({ params }) => {
    const bookmark = bookmarks.find((b) => b.id === params.id);
    return HttpResponse.json({ success: true, data: bookmark });
  }),
  http.get(api('/api/bookmarks/:id'), ({ params }) => {
    const bookmark = bookmarks.find((b) => b.id === params.id);
    return HttpResponse.json({ success: true, data: bookmark });
  }),

  // POST /api/bookmarks
  http.post('/api/bookmarks', async ({ request }) => {
    const body = (await request.json()) as CreateBookmark;
    const newBookmark = getDummyBookmark({
      id: `bookmark-${Date.now()}`,
      url: body.url,
      title: body.title ?? undefined,
      description: body.description ?? undefined,
    });
    bookmarks.push(newBookmark);
    return HttpResponse.json({ success: true, data: newBookmark }, { status: 201 });
  }),
  http.post(api('/api/bookmarks'), async ({ request }) => {
    const body = (await request.json()) as CreateBookmark;
    const newBookmark = getDummyBookmark({
      id: `bookmark-${Date.now()}`,
      url: body.url,
      title: body.title ?? undefined,
      description: body.description ?? undefined,
    });
    bookmarks.push(newBookmark);
    return HttpResponse.json({ success: true, data: newBookmark }, { status: 201 });
  }),

  // PUT /api/bookmarks/:id
  http.put('/api/bookmarks/:id', async ({ request }) => {
    const body = (await request.json()) as UpdateBookmark;
    const newBookmark = getDummyBookmark({
      id: `bookmark-${Date.now()}`,
      url: body.url ?? 'https://example.com',
      title: body.title ?? null,
      description: body.description ?? null,
    });
    return HttpResponse.json({ success: true, data: newBookmark });
  }),
  http.put(api('/api/bookmarks/:id'), async ({ request }) => {
    const body = (await request.json()) as UpdateBookmark;
    const newBookmark = getDummyBookmark({
      id: `bookmark-${Date.now()}`,
      url: body.url ?? 'https://example.com',
      title: body.title ?? null,
      description: body.description ?? null,
    });
    return HttpResponse.json({ success: true, data: newBookmark });
  }),

  // DELETE /api/bookmarks/:id
  http.delete('/api/bookmarks/:id', () => {
    return HttpResponse.json({ success: true, data: null });
  }),
  http.delete(api('/api/bookmarks/:id'), () => {
    return HttpResponse.json({ success: true, data: null });
  }),
];
